import React from 'react';
import { Text } from '../../../../components/Typography/Typography';
import { EvaluationGroup } from '../../../../store/evaluation/types';
import Button from '../../../../components/UI/Button';
import EvaluationScore from '../../../../components/EvaluationScore/EvaluationScore';
import EvaluationModal from './EvaluationModal';
import styles from './EvaluationRow.module.scss';

interface Props {
  group: EvaluationGroup;
  isModalOpen: boolean;
  onModalOpen: () => void;
  onModalClose: () => void;
  onNavigate?: (direction: 'prev' | 'next') => void;
  onGroupUpdate: (updatedGroup: EvaluationGroup) => void;
}

const EvaluationRow: React.FC<Props> = ({
  group,
  isModalOpen,
  onModalOpen,
  onModalClose,
  onNavigate,
  onGroupUpdate,
}) => {
  const { evaluations } = group;
  const firstEval = evaluations[0];
  const traceUrl = firstEval?.trace_url;

  // Transform evaluations into scores array
  const scores = evaluations.map((evaluation) => ({
    name: evaluation.name || 'Unknown',
    score: evaluation.score,
  }));

  // Find the first question in the group's evaluations
  const firstQuestion = evaluations.find((evaluation) => evaluation.input.question)?.input.question;

  return (
    <>
      <div className={styles.row} onClick={onModalOpen} style={{ cursor: 'pointer' }}>
        <div className={styles.triggerColumn}>
          <div className={styles.triggerInfo}>
            <Text weight="medium">{firstEval?.trigger_type}</Text>
            {firstEval?.trigger_id && (
              <Text color="neutral-600" element="span" className={styles.triggerId}>
                {firstEval.trigger_id}
              </Text>
            )}
          </div>
        </div>
        <div className={styles.questionColumn}>
          <Text color="neutral-600">{firstQuestion}</Text>
        </div>
        <div className={styles.scoreColumn}>
          <EvaluationScore scores={scores} />
        </div>
        <div className={styles.actionColumn}>
          {traceUrl && (
            <Button
              variant="ghost"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                window.open(traceUrl, '_blank');
              }}
            >
              View Trace
            </Button>
          )}
        </div>
      </div>

      <EvaluationModal
        group={group}
        isOpen={isModalOpen}
        onClose={onModalClose}
        onNavigate={onNavigate}
        onGroupUpdate={onGroupUpdate}
      />
    </>
  );
};

export default EvaluationRow;
